(function() {
	'use strict';

	function injectFigure($figureItem) {

		var $htmlDiscountFigure = $figureItem.html();
		var $discountItem = $figureItem.closest(".js-text-discount");
	
		$discountItem.html($discountItem.html().replace($htmlDiscountFigure, ""));
		$discountItem.html($discountItem.html().replace("#jsonFigure.discount#", $htmlDiscountFigure));
	}

	$(".js-text-discount-figure").each(function() {
		injectFigure($(this));
	});

})();
